"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _default = exports.default = {
  props: ['network'],
  data: function data() {
    return {
      sidebarOpen: false,
      page: 0,
      page_size: 200,
      search: '',
      last_updated: 0
    };
  },
  computed: {
    noResults() {
      return this.listState === 'updated' && this.filteredList.length === 0;
    },
    isLoading() {
      return this.listState === 'updating';
    },
    listState() {
      return this.network.channel_list_state;
    },
    list() {
      return this.network.channel_list || [];
    },
    filteredList() {
      let list = [];
      if (this.search.length <= 2) {
        list = this.list;
      } else {
        list = this.list.filter(channel => {
          let found = false;
          if (channel.channel.toLowerCase().indexOf(this.search) > -1) {
            found = true;
          }
          if (channel.topic.toLowerCase().indexOf(this.search) > -1) {
            found = true;
          }
          return found;
        });
      }
      return _lodash.default.sortBy(list, 'num_users').reverse();
    },
    paginated() {
      let offset = this.page * this.page_size;
      let list = this.filteredList;
      let channels = [];
      for (let i = offset; i < offset + this.page_size; i++) {
        if (list[i]) {
          channels.push(list[i]);
        }
      }
      return channels;
    },
    maxPages() {
      return Math.floor(this.filteredList.length / this.page_size);
    },
    canGoForward() {
      return this.page * this.page_size >= this.filteredList.length;
    },
    canGoBackward() {
      return this.page > 0;
    }
  },
  watch: {
    search() {
      this.page = 0;
    }
  },
  methods: {
    nextPage() {
      if (this.page < this.maxPages) {
        this.page++;
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page--;
      }
    },
    maybeUpdateList() {
      this.network.maybeUpdateChannelList();
    },
    formatAndTrimTopic(rawTopic) {
      let showModes = this.$state.setting('showChanlistModes');
      let topic = showModes ? rawTopic : rawTopic.replace(/^\[([^\]]+)\] ?/, '');
      let blocks = (0, _MessageParser.default)(topic, {
        extras: false
      });
      let content = (0, _Html.default)(blocks);
      return content;
    },
    joinChannel(channelName) {
      let buffer = this.$state.getBufferByName(this.network.id, channelName);
      if (buffer) {
        // Switch buffer if its already exists
        this.$state.setActiveBuffer(this.network.id, channelName);
        return;
      }
      this.$state.addBuffer(this.network.id, channelName);
      this.network.ircClient.join(channelName);
      if (this.$state.ui.is_narrow) {
        // This is a mobile device
        // Switch to the channel so the user can see something happend
        this.$state.setActiveBuffer(this.network.id, channelName);
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelList"]
window._kiwi_exports.components.ChannelList = exports.default ? exports.default : exports;
